import { Component, Vue, Prop } from "vue-property-decorator";
import { getProblemList, postFeedBack } from "@/api/course";
import { isEmpty, isExpression } from "@/libs/tools";
import { Mutation, State } from "vuex-class";
@Component
export default class FeedBack extends Vue {
    @Prop() readonly currentSectionId: any;
    private centerDialogVisible: boolean = false;
    private feedDetail: any = {
        type: "",
        content: "",
        location: {}
    };
    private fbType: Array<object> = [];
    private feedType: boolean = false;
    private feedContent: boolean = false;
    private feedEmoji: boolean = false;

    get isShowFeedBack() {
        return this.$store.state.aistudy.isShowFeedBack;
    }

    @Mutation("aistudy/changeShowFeedBack") changeShowFeedBackFlag:
        | boolean
        | undefined;

    handleFeedBackClick() {
        getProblemList().then(res => {
            // this.centerDialogVisible = true;
            // this.$store.state.aside.isShowFeedBack = true;
            //@ts-ignore
            this.changeShowFeedBackFlag(!this.isShowFeedBack);
            // @ts-ignore
            if (res.code === 200) {
                this.fbType = res.data;
            } else {
                // @ts-ignore
                this.$message.success(res.msg);
            }
        });
    }
    /**
     * 提交反馈
     */
    submitFeedback() {
        if (isEmpty(this.feedDetail.type)) {
            // this.$message.error("请选择问题类型");
            this.feedType = true;
            return;
        } else if (isEmpty(this.feedDetail.content)) {
            // this.$message.error("请填写内容");
            this.feedContent = true;
            return;
        } else if (isExpression(this.feedDetail.content)) {
            // this.$message.error("暂不支持表情哦~");
            this.feedEmoji = true;
            return;
        } else {
            this.feedDetail.location.sectionId = this.currentSectionId;
            this.feedDetail.location = JSON.stringify(this.feedDetail.location);
            postFeedBack(this.feedDetail).then(res => {
                // @ts-ignore
                if (res.code === 200) {
                    this.$message.success("已收到，感谢您的反馈");
                    // this.centerDialogVisible = false;
                    // this.$store.state.aside.isShowFeedBack = false;
                    //@ts-ignore
                    this.changeShowFeedBackFlag(false);
                    this.feedDetail.content = "";
                    this.feedDetail.type = "";
                    this.feedDetail.location = {};
                }
            });
        }
    }
    focus() {
        this.feedContent = false;
        this.feedEmoji = false;
    }
    handleSelected(val) {
        this.feedType = false;
    }
    closeFeedBack() {
        this.feedDetail.content = "";
        this.feedDetail.type = "";
        // this.centerDialogVisible = false;
        // this.$store.state.aside.isShowFeedBack = false;
        //@ts-ignore
        this.changeShowFeedBackFlag(false);
    }
}
// @ts-ignore
export { default as FeedBack } from "./index.vue";
